<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    title="变动单价详情"
    width="70%"
    append-to-body
  >
    <div class="dialog-content">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="fileTableRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="200"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
        >
          <template v-slot="{ row }">
            <span>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';
  export default {
    name: 'ProductDescDialog',
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        tableColumnList: [
          {
            field: 'productDesc',
            title: '商品描述',
          },
          {
            field: 'productQuantity',
            title: '数量',
          },
          {
            field: 'productUnitName',
            title: '单位',
          },
          {
            field: 'salesUnitPrice',
            title: '合同单价',
          },
          {
            field: 'priceIdentityName',
            title: '价格标识',
          },
          {
            field: 'temporaryPrice',
            title: '变动价格',
          },
          {
            field: 'confirmDate',
            title: '价格确定时间',
          },
          {
            field: 'operatorName',
            title: '操作人',
          },
          {
            field: 'pricingStatusName',
            title: '状态',
          },
        ],
      };
    },
    methods: {
      openModal(row) {
        this.getOrderPriceDetail(row.contractDetailNo, row.version);
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      confirmHandler() {
        if (this.selectionList.length) {
          this.cancelHandler();
        } else {
          this.$message.error('请选择行');
        }
      },
      //获取当前行项目明细
      getOrderPriceDetail(contractDetailNo, version) {
        this.loading = true;
        this.$axios
          .post(API.GET_ORDERSALEDETAIL_API, {
            contractNo: this.$route.query.contractNo,
            contractDetailNo: contractDetailNo,
            version: version,
          })
          .then((res) => {
            this.dialogVisible = true;
            if (0 != res.data.code) {
              this.$alert(res.data.msg);
            } else {
              this.tableData = res.data.data;
              // //更新父组件的最新变动价格
              // this.$emit('updateProduct', {
              //   prop: 'priceChange',
              //   val: res.data.data,
              // });
              // this.dialogAdd = false;
              // this.$message({
              //   type: 'success',
              //   message: this.$t('message.success'),
              // });
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dialog-content {
    ::v-deep .vxe-toolbar {
      display: none;
    }
  }
</style>
